import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Grid2, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
const Registro = () => {
  return (
    <Box>
      <Stack spacing={4}>
        <Grid2 container>
          <Grid2
            size={{ xs: 12, md: 12, lg: 12 }}
            style={{ padding: "5%", textAlign: "justify" }}
          >
            <Stack spacing={4}>
              <Typography variant="h1">Registro</Typography>
              <Typography variant="p" style={{ fontSize: "1.5em" }}>
                Si presenta alguna dificultad o inconveniente para registrarse o
                si necesita inscribir a un grupo de personas, favor escribanos a
                ebg@ebg.edu.gt para asistirle
              </Typography>
              <Typography variant="p" style={{ fontSize: "1.5em" }}>
                Necesitará usar un e-mail diferente para cada persona. Si elige
                la inscripción grupal el sistema le hará la sumatoria con los
                descuentos que correspondan por volumen y la Asociación Bancaria
                le enviará al administrador de dicho grupo una nota de cargo
                para que tramite el pago correspondiente.
              </Typography>
              <Button
                style={{
                  backgroundColor: "#e0721d",
                  color: "white",
                  border: "1px solid transparent",
                }}
                startIcon={<DriveFileRenameOutlineIcon />}
                onClick={() => {
                  window.open(
                    `https://ebg.edu.gt/inscripcion/${process.env.REACT_APP_EVT}`,
                    "_blank"
                  );
                }}
              >
                Click para registrarse
              </Button>
            </Stack>
          </Grid2>
        </Grid2>
      </Stack>
    </Box>
  );
};

export default Registro;
